import { buildApiUrl } from "@/config/api";
import { useAuthStore } from "@/authen/auth";

/**
 * Client + server check for IPA team owner flows (match-hub-status API).
 * @returns {Promise<{ ok: boolean, reason?: string, has_customer?: boolean, has_team?: boolean }>}
 */
async function fetchMatchHubStatus(path) {
  const auth = useAuthStore();
  auth.checkToken();
  if (!auth.isAuthenticated) {
    return { ok: false, reason: "unauthenticated" };
  }
  const token = (auth.accessToken || localStorage.getItem("access_token") || "").trim();
  if (!token) {
    return { ok: false, reason: "unauthenticated" };
  }
  try {
    const response = await fetch(buildApiUrl(path), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 401) {
      return { ok: false, reason: "session" };
    }
    if (!response.ok) {
      return { ok: false, reason: "error" };
    }
    const data = await response.json();
    return {
      ok: true,
      has_customer: Boolean(data.has_customer),
      has_team: Boolean(data.has_team),
      sport: data.sport || null,
    };
  } catch {
    return { ok: false, reason: "error" };
  }
}

/** Football squad owner access (legacy default). */
export async function verifyMatchHubTeamOwnerAccess() {
  return fetchMatchHubStatus("/api/teams/match-hub-status");
}

/** Basketball squad owner access. */
export async function verifyBasketballTeamOwnerAccess() {
  return fetchMatchHubStatus("/api/teams/basketball/match-hub-status");
}
